import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Link } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';

import { useCompanyPageSelectionStageStyles } from '../styles/company-page-selection-stage-styles';

export const TermsAndConditions = ({ checked, onChange }) => {
  const i18n = useContext(I18nContext);
  const classes = useCompanyPageSelectionStageStyles();

  const label = useMemo(() => {
    const template = i18n.getString(_TL_('By connecting to your company’s page, you agree that the {{link}}LinkedIn Ads Agreement{{/link}} will govern your LinkedIn campaigns.'));

    return (
      <ReactTemplate
        template={template}
        model={{
          link: text => (
            <Link
              aria-label={i18n.getString(_TL_('LinkedIn Ads Agreement'))}
              href="https://www.linkedin.com/legal/sas-terms"
              target="_blank"
              rel="noopener noreferrer"
              inline
            >
              {text}
            </Link>
          ),
        }}
      />
    );
  }, [i18n]);

  const handleChange = useCallback(() =>
    onChange(!checked), [checked, onChange]);

  return (
    <Checkbox
      label={label}
      checked={checked}
      onChange={handleChange}
      className={classes.termsAndConditions}
    />
  );
};

TermsAndConditions.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
